
import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"
import { http } from '@/utils/http.js'
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        menuCollapse: false,
        token: '',
        routes: [],
        menus: [],
        userInfo: {}
    },
    getters: {
    },
    mutations: {
        clearUserInfo(state) {
            state.userInfo = null;
        },
        setmenuCollapse(state) {
            state.menuCollapse = !state.menuCollapse
        },
        setUserInfo(state, payload) {
            state.userInfo = payload
        },
        setToken(state, payload) {
            state.token = payload
        },
        delToken(state) {
            state.token = ''
        },
        setRoutes(state, routes) {
            state.routes = routes
        },
        delRoutes(state) {
            state.routes = []
        },
        setMenus(state, menus) {
            state.menus = menus
        },
        delMenus(state) {
            state.menus = []
        }

    },
    actions: {
    },
    plugins: [createPersistedState()]
})
